import Dialog from '@mui/material/Dialog';
import { Theme } from '@mui/material/styles';
import React, { Suspense, useContext } from 'react';
import { DialogVariantOptions } from 'shared/assets/styles';
import { PageLoader } from 'shared/components/ui/page-loader';
import { TaskDetailContext } from 'shared/contexts/task-detail/task-detail-context';
import { ID } from 'shared/types/id';
import { CreateTask } from 'shared/types/task';
import { MetaViewOptions } from 'shared/views/task-detail';

import * as Styled from './task-detail-dialog.style';
import { TaskDetailWrapper } from './task-detail-wrapper';

// todo: as it is just styling, this should not be implemented like this. Styling belongs in styled-components
const slotProps = {
  paper: {
    sx: {
      background: (theme: Theme) => theme.palette.background.default,
      backdropFilter: 'none',
    },
  },
};

export type TaskDetailDialogProps = {
  onClose: () => void;
  taskId?: ID;
  initialValues?: Partial<CreateTask>;
  openOnView?: MetaViewOptions;
};

export const TaskDetailDialog: React.FC<TaskDetailDialogProps> = ({
  onClose,
  taskId,
  initialValues,
  openOnView,
}) => {
  const { isSubmenuOpen } = useContext(TaskDetailContext);
  const open = !!taskId || !!initialValues;

  const _onClose = (e: object, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (reason === 'escapeKeyDown' && isSubmenuOpen) {
      return;
    }

    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={_onClose}
      variant={DialogVariantOptions.MediumLarge}
      slotProps={slotProps}
    >
      <Styled.Container>
        {open && (
          <Suspense fallback={<PageLoader />}>
            <TaskDetailWrapper
              onClose={onClose}
              taskId={taskId}
              initialValues={initialValues}
              openOnView={openOnView}
            />
          </Suspense>
        )}
      </Styled.Container>
    </Dialog>
  );
};
